/* eslint-disable prettier/prettier */

/* 
  Admin create order page - here be dragons
  There is a LOT of legacy code, undocumented, dense
  Please try to comment and fix as you go.

  Last updated 2025-03-21 by Owen: POOL TO SHIFT
  * I moved the logic to Jobs level - this should be at JOB level not ROUTE level (so that we can
  correctly handle job level status updates, as well as add stops to existing routes w/o issues)

  Each job will have:
  * jobs.poolStatus will be undefined (for non) or "submitted", "at_warehouse", or unhandled
  * jobs.isPoolToShift will be undefined or true


                                             Pickup Location
                            Pickup Route   <  Delivery - at warehouse
         PoolV2 Package <
                            Dropoff Route  < Pickup - at warehouse
                                            Delivery Location

Need better verbiage due to overloaded terms:
  Pickup Route aka "submitted" status = pickup to warehouse
  DropoffRoute aka "at_warehouse" stat = warehouse to delivery

We currently do NOT handle failures or returns; I'm going to set those PackageV2 to "pending"
and our team can handle manually.

*/

import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser } from "../../../auth/store/authSlice";
import {
  resetNewOrderStatuses,
  saveAsDraftNewOrder,
  selectNewOrder
} from "../../../client/active-orders/store/orderSlice";
import StopOrderingSelect from "../../../client/active-orders/components/StopOrderingSelect";
import { DEFAULT_STOP_ORDER_MODE } from "../../../client/active-orders/stopOrderModes";
import ReturnProcessSelect from "../../../client/active-orders/components/return-process/ReturnProcessSelect";
import useClientReturnProcess from "../../../client/active-orders/components/return-process/useClientReturnProcess";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { ProfileContext } from "../../../../layouts/private/ProfileContext";
import { useHistory } from "react-router-dom";
import moment from "moment/moment";
import { DAY_DATE_FORMAT } from "../../../../configs/constants";
import {
  Button,
  Col,
  Collapse,
  Form,
  Input,
  message,
  Modal,
  notification,
  Popconfirm,
  Row,
  Select,
  Switch,
  Typography
} from "antd";
import { selectAllPackageTypes } from "../../../client/package-types/store/slice";
import { selectAllFlexioServices } from "../../../client/flexio-services/store/slice";
import { ReactSVG } from "react-svg";
import { selectAllDrivers } from "../../drivers/store/slice";
import { getDriverList } from "../../drivers/store/thunks";
import { buildFirstLevelFilter } from "../../clients/helper";
import request from "../../../../helper/request";
import groupBy from "lodash/groupBy";
import { getPackageTypeList } from "../../../client/package-types/store/thunks";
import { getFlexioServiceList } from "../../../client/flexio-services/store/thunks";
import {
  filterValidRoutes,
  getJobs,
  initRoutes,
  routeEstimateDefault
} from "../../../client/active-orders/helper";
import isEmpty from "lodash/isEmpty";
import { isInternalDriverService } from "../../../client/flexio-services/helper";
import uniq from "lodash/uniq";
import sumBy from "lodash/sumBy";
import {
  convertArrayToObject,
  convertObjectToArray,
  formatDateToBackend,
  fullName,
  handleTitleTab,
  makeId
} from "../../../../helper/util";
import { ROUTE_ESTIMATE_TYPES } from "../../../client/active-orders/constants";
import { doCreateActiveOrder } from "../../../client/active-orders/store/thunks";
import _find from "lodash/find";
import { setSuccessMessage } from "../../../../app/global/slice";
import OrdersHeader from "../../../client/active-orders/components/header/OrdersHeader";
import MapImportPreview from "../../../client/routes/components/maps/MapImportPreview";
import SiderForm from "../../../client/active-orders/components/SiderForm";
import keys from "lodash/keys";
import AddressFormAdmin from "modules/admin/orders/components/AddressFormAdmin";
import PackageList from "../../../client/active-orders/components/PackageList";
import PackageListDrop from "../../../client/active-orders/components/PackageListDrop";
import ServiceStep from "../../../client/active-orders/components/steps/ServiceStep";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckCircleOutlined,
  CheckOutlined,
  SearchOutlined
} from "@ant-design/icons";
import PackForm from "../../../client/active-orders/components/form/PackForm";
import SelectPack from "../../../client/active-orders/components/form/SelectPack";
import "../../../client/active-orders/pages/CreateOrderPage.scss";
import ConfirmRoutePageAdmin from "./ConfirmRoutePageAdmin";
import { DND_STATUSES } from "modules/shared/PickupDropoff/constants";

const { Panel } = Collapse;

const { Paragraph } = Typography;

const routesInit = initRoutes();

const init = {
  id: `${new Date().getTime()}-${makeId(4)}` + ("Pickup" || "Dropoff"),
  title: "Pickup Location" || "Dropoff Location",
  position: 1,
  value: "text",
  address: { address: "", lngLat: [] },
  from_time: moment("08:00", "HH:mm"),
  to_time: moment("17:00", "HH:mm"),
  duration: 10,
  phone_numbers: [{ type: "contact", phone: "" }]
};

const pickupsInit = [
  {
    ...init,
    id: `${new Date().getTime()}-${makeId(4)}-Pickup`,
    title: "Pickup Location"
  }
];

const dropoffsInit = [
  {
    ...init,
    id: `${new Date().getTime()}-${makeId(4)}-Dropoff`,
    title: "Drop-off Location"
  }
];

const imagesInit = {
  pickups: {},
  dropoffs: {}
};

const breadCrumbs = [{ text: "ACTIVE ORDERS", url: "/routes" }, { text: "CREATE ORDER" }];

let isSelectRouteNumber;
let dndStatus;

const requiredFields = {
  location_name: "Location Name",
  address: "address",
  from_time: "Pickup From Time Window",
  to_time: "Pickup To Time Window",
  duration: "Duration",
  contact_name: "Contact Name"
};

const AdminCreateOrderPage = ({ isAdmin }) => {
  const dispatch = useDispatch();

  const currentUser = useSelector(selectCurrentUser);
  const newOrder = useSelector(selectNewOrder);
  const isLoading = useSelector((state) => state.global.isLoading);

  const profileCtx = useContext(ProfileContext);
  const history = useHistory();
  const profile = useMemo(() => profileCtx?.profile, [profileCtx]);
  const [groupedClients, setGroupedClients] = useState({});
  const [allClients, setAllClients] = useState([]);
  const [clientId, setClientId] = useState();
  const [clientType, setClientType] = useState();
  const [driverId, setDriverId] = useState();
  const [jobs, setJobs] = useState({});
  const [routes, setRoutes] = useState(routesInit);
  const [pickupDate, setPickupDate] = useState(moment(new Date(), DAY_DATE_FORMAT));
  const [form] = Form.useForm();
  const [formPack] = Form.useForm();
  const [formSelectPack] = Form.useForm();
  const [packages, setPackages] = useState([]);
  const [pickups, setPickups] = useState(pickupsInit);
  const [dropoffs, setDropoffs] = useState(dropoffsInit);
  const [visible, setVisible] = useState(false);
  const [isAllPackage, setIsAllPackage] = useState(true);
  const [isOptimizeRoute, setIsOptimizeRoute] = useState(true);
  const [type, setType] = useState("pickups");
  const [selectedPack, setSelectedPack] = useState(null);
  const [keysPick, setKeysPick] = useState([pickupsInit[0].id]);
  const [keysDrop, setKeysDrop] = useState([dropoffsInit[0].id]);
  const [confirmLocations, setConfirmLocations] = useState(false);
  const [selectedInfo, setSelectedInfo] = useState({
    id: null,
    typePack: null
  });
  const [imagesAddressInfo, setImagesAddressInfo] = useState(imagesInit);
  const [idErrors, setIdErrors] = useState({
    pickups: [],
    dropoffs: []
  });
  const [isConfirmRoute, setIsConfirmRoute] = useState(false);
  const [collapseStepsActiveKey, setCollapseStepsActiveKey] = useState(1);

  const packageTypeList = useSelector(selectAllPackageTypes);
  const flexioServices = useSelector(selectAllFlexioServices)?.filter(
    (service) => !isAdmin || !service.isInternalDriver
  );

  const [isEmptyPickupAddress, setIsEmptyPickupAddress] = useState(
    !pickups.map((pickup) => pickup.address.lngLat[0] !== undefined).every((item) => item)
  );
  const [isEmptyDropoffAddress, setIsEmptyDropoffAddress] = useState(
    !dropoffs
      .map((dropoff) => dropoff.address.lngLat[0] !== undefined)
      .every((item) => item)
  );

  const [isEmptyPhone, setIsEmptyPhone] = useState();

  const queryParams = new URLSearchParams(window.location.search);
  const serviceQueryId = queryParams.get("selectedService");
  const selectedService = flexioServices.find((service) => service.id === serviceQueryId);
  const [confirmLocationsNext, setConfirmLocationsNext] = useState(false);

  const expandIconDynamic = (props) => {
    if (props.isActive) {
      return <ReactSVG src="/icons/collapse.svg" />;
    } else {
      return <ReactSVG src="/icons/dropoff.svg" />;
    }
  };
  const disAllPack = dropoffs.length > 1;

  useEffect(() => {
    // In every change in dropoff, update isAllPackage
    setIsAllPackage(!disAllPack);
  }, [disAllPack]);

  useEffect(() => {
    if (queryParams.get("action") === "new") {
      dispatch(resetNewOrderStatuses());
    }
    // eslint-disable-next-line
  }, []);
  const allDrivers = useSelector(selectAllDrivers);

  useEffect(() => {
    dispatch(
      getDriverList({
        pageSize: 3000,
        filter: buildFirstLevelFilter({ active: true, is_internal_driver: false })
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchClients = async () => {
      const tmpClients = await request.get("/admin/clients/all-clients");
      setAllClients(tmpClients);
      setGroupedClients(groupBy(tmpClients, "clientType"));
    };
    dispatch(getPackageTypeList());
    fetchClients();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const companyId = form.getFieldValue("clientId");
    if (isAdmin && clientId) {
      dispatch(getFlexioServiceList({ clientId: companyId }));
    }
    // eslint-disable-next-line
  }, [dispatch, form.getFieldValue("clientId")]);

  useEffect(() => {
    let defaultPickups = newOrder.pickups || pickupsInit;
    let defaultDropoffs = newOrder.dropoffs || dropoffsInit;
    const defaultJobs = newOrder.jobs || {};
    const defaultRoutes = filterValidRoutes(newOrder.routes) || {};

    setClientId(newOrder?.clientId);
    setDriverId(newOrder?.driverId);
    setIsConfirmRoute(newOrder?.isConfirmRoute || false);
    // Only sync confirmLocations from Redux if explicitly set to true (e.g., from PlanListPage)
    // Don't overwrite local state if Redux value is false/undefined (normal flow)
    if (newOrder?.isConfirmLocations) {
      console.log("=== PLAN FLOW DETECTED: Setting confirmLocations to true ===");
      setConfirmLocations(newOrder.isConfirmLocations);
      // Use setTimeout to ensure panels are rendered before setting activeKey
      // Set to "route-optimization" to open Step 4 (Route Optimization) when coming from plan flow
      setTimeout(() => {
        console.log("=== Setting collapseStepsActiveKey to 'route-optimization' ===");
        setCollapseStepsActiveKey("route-optimization");
      }, 100);
    }
    if (newOrder?.isConfirmRoute) {
      setCollapseStepsActiveKey(null);
      setType("service");
    }
    setJobs(defaultJobs);
    setRoutes(defaultRoutes);
    if (!isEmpty(newOrder)) {
      defaultPickups = defaultPickups.map((dPick) => ({
        ...dPick,
        locationNum: dPick?.locationNum || 0 + 1
      }));
      defaultDropoffs = defaultDropoffs.map((dDrop) => ({
        ...dDrop,
        locationNum: dDrop?.locationNum || 0 + 1
      }));
      setIsOptimizeRoute(newOrder.isOptimizeRoute);
      if (defaultPickups[0]) setKeysPick([defaultPickups[0].id]);
      if (defaultDropoffs[0]) setKeysDrop([defaultDropoffs[0].id]);
    }
    setPickupDate(
      newOrder.pickupDate
        ? moment(newOrder.pickupDate)
        : moment(new Date(), DAY_DATE_FORMAT)
    );
    setImagesAddressInfo(newOrder?.imagesAddressInfo || imagesInit);
    setPackages(newOrder.packages || []);
    setPickups(defaultPickups);
    setDropoffs(defaultDropoffs);

    form.setFieldsValue({
      pickups: defaultPickups.map((pick) => {
        return {
          ...pick,
          from_time: pick.from_time ? moment(pick.from_time) : null,
          to_time: pick.to_time ? moment(pick.to_time) : null
        };
      }),
      dropoffs: defaultDropoffs.map((drop) => {
        return {
          ...drop,
          from_time: drop.from_time ? moment(drop.from_time) : null,
          to_time: drop.to_time ? moment(drop.to_time) : null
        };
      }),
      clientId: newOrder.clientId,
      driverId: newOrder.driverId
    });
  }, [form, newOrder]);

  const redirectUri = useMemo(
    () => "/admin/jobs/confirm-route",
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const onChangeTypeMenu = async (value) => {
    setType(value.key);
    if (value.key !== "service" && !!idErrors[value.key].length) {
      setTimeout(() => {
        form
          .validateFields()
          .then(() => {})
          .catch(() => {});
      }, 1500);
    }
  };

  const validateRouteData = () => {
    const allPickups = form.getFieldValue("pickups") || [];
    const allDropoffs = form.getFieldValue("dropoffs") || [];
    const errorGroups = [];

    if (allPickups.length === 0) {
      errorGroups.push({
        type: "General",
        errors: ["At least one pickup is required"]
      });
    }
    if (allDropoffs.length === 0) {
      errorGroups.push({
        type: "General",
        errors: ["At least one dropoff is required"]
      });
    }

    const isValidTime = (time) => {
      if (!time) return false;
      if (moment.isMoment(time)) return time.isValid();
      const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
      return timeRegex.test(time);
    };

    allPickups.forEach((pickup, index) => {
      const pickupNum = index + 1;
      const errors = [];

      if (!pickup?.address?.address) {
        errors.push("Address is required");
      }
      if (!isValidTime(pickup?.from_time)) {
        errors.push("Valid time window start is required (HH:mm format)");
      }
      if (!isValidTime(pickup?.to_time)) {
        errors.push("Valid time window end is required (HH:mm format)");
      }

      // Check for unassigned packages for this pickup
      const unassignedCount = packages.filter(
        (pack) =>
          pack.pickupId === pickup.id && (!pack.dropoffs || pack.dropoffs.length === 0)
      ).length;
      if (unassignedCount > 0) {
        errors.push(
          `Has ${unassignedCount} unassigned package${unassignedCount > 1 ? "s" : ""}`
        );
      }

      if (errors.length > 0) {
        errorGroups.push({ type: `Pickup ${pickupNum}`, errors });
      }
    });

    allDropoffs.forEach((dropoff, index) => {
      const dropoffNum = index + 1;
      const errors = [];

      if (!dropoff?.address?.address) {
        errors.push("Address is required");
      }
      if (!isValidTime(dropoff?.from_time)) {
        errors.push("Valid time window start is required (HH:mm format)");
      }
      if (!isValidTime(dropoff?.to_time)) {
        errors.push("Valid time window end is required (HH:mm format)");
      }

      if (errors.length > 0) {
        errorGroups.push({ type: `Dropoff ${dropoffNum}`, errors });
      }
    });

    return { isValid: errorGroups.length === 0, errorGroups };
  };

  const checkDataAdressForm = (data, stopType) => {
    const ids = [];
    const fieldRequired = [
      "address",
      "from_time",
      "to_time",
      "duration",
      "location_name",
      "contact_name"
    ];
    data.forEach((element) => {
      let isError = false;
      const fieldsError = [];
      fieldRequired.forEach((field) => {
        let value = element[field];
        if (field === "address") value = element.address?.address;
        if (!isError && !value) {
          fieldsError.push(field);
        }
      });

      if (fieldsError.length) {
        isError = true;
      }

      console.log(fieldsError);

      if (isError) {
        fieldsError.map((fieldError) => {
          ids.push({ id: element.id, fieldError });
        });
      }
    });
    return ids;
  };

  const onFinishOrder = async () => {
    //console.log("🦾 onFinishOrder");
    let messageError = [];
    setKeysDrop([]);
    setKeysPick([]);
    const newIdsError = { ...idErrors };

    if (!clientId) {
      messageError.push("Please select a client");
    }

    // Check if selected client is blocked
    if (clientId) {
      const selectedClient = allClients.find((client) => client.id === clientId);
      if (selectedClient && selectedClient.isBlocked) {
        const confirmed = await new Promise((resolve) => {
          Modal.confirm({
            title: "Warning: Client is Blocked",
            content: (
              <div>
                <p style={{ color: "#ff4d4f", fontWeight: "bold", marginBottom: "12px" }}>
                  ⚠️ The selected client &quot;{selectedClient.clientName}&quot; is
                  currently blocked.
                </p>
                <p>
                  <strong>Blocked At:</strong>{" "}
                  {selectedClient.blockedAt
                    ? new Date(selectedClient.blockedAt).toLocaleString()
                    : "N/A"}
                </p>
                <p>
                  <strong>Blocked By:</strong> {selectedClient.blockedBy || "N/A"}
                </p>
                {selectedClient.blockReason && (
                  <p>
                    <strong>Reason:</strong> {selectedClient.blockReason}
                  </p>
                )}
                <p style={{ marginTop: "12px" }}>
                  Do you want to proceed with creating routes for this blocked client?
                </p>
              </div>
            ),
            okText: "Yes, Proceed",
            cancelText: "Cancel",
            okType: "danger",
            icon: null,
            width: 500,
            onOk: () => resolve(true),
            onCancel: () => resolve(false)
          });
        });

        if (!confirmed) {
          return; // Stop the order creation process
        }
      }
    }

    const { isValid, errorGroups } = validateRouteData();
    if (!isValid) {
      errorGroups.forEach((group) => {
        group.errors.forEach((error) => {
          messageError.push(`${group.type}: ${error}`);
        });
      });
    }

    const routeValidationMessages = checkRoutes();
    if (routeValidationMessages?.length)
      messageError = messageError.concat(routeValidationMessages);

    if (messageError.length) {
      const descriptionElement = (
        <Paragraph style={{ marginRight: 15 }}>
          <ul>
            {messageError.map((msg, i) => (
              <li key={`mess-${i}`}>{msg}</li>
            ))}
          </ul>
        </Paragraph>
      );
      notification.error({
        description: descriptionElement,
        placement: "topRight",
        style: {
          width: "auto"
        }
      });
      form.validateFields();
    } else {
      saveData();
    }
  };

  const checkRoutes = () => {
    const routeErrors = [];
    const routeKeys = Object.keys(routes);
    if (routeKeys?.length) {
      for (const routeKey of routeKeys) {
        const route = routes[routeKey];
        if (!route?.vehicleCategoryId && !isInternalDriverService(route?.service?.name)) {
          routeErrors.push(`${route.name}: Please choose a Vehicle for the route `);
        }
        if (!route?.serviceId) {
          routeErrors.push(`${route.name}: Please choose a Service for the route`);
        }
      }
    }
    return routeErrors;
  };

  const checkPackages = () => {
    const pickupsIdsHasPack = uniq(packages.map((pack) => pack.pickupId));
    const picksNotPack = pickups.filter((p) => !pickupsIdsHasPack.includes(p.id)) || [];
    const messageError = [];
    if (picksNotPack.length) {
      `${picksNotPack.map((pick) => {
        if (pick) {
          messageError.push(
            `${pick.title} ${pick.position}: Please select some packages`
          );
        }
      })}`;
    }

    let isQuantityCurrent = false;
    if (!isAllPackage) {
      packages.forEach((pack) => {
        const quantityCurrent = pack.quantity;

        if (pack?.dropoffs?.length) {
          const quantityTotal = sumBy(pack.dropoffs, "quantity");
          isQuantityCurrent = quantityCurrent - quantityTotal !== 0;
        } else {
          isQuantityCurrent = true;
        }
      });
    }
    if (isQuantityCurrent) {
      messageError.push("Some packages haven't been assigned to any drop-off");
    }

    return messageError;
  };

  const handleAddJobsToRoutes = () => {
    const tmpJobs = convertObjectToArray(jobs, "id");
    const unscheduledJobs = tmpJobs.filter((j) => j.routeId === "unscheduled");
    let tmpRoutes = {};
    Object.keys(newOrder.routes).map((key) => {
      // Do NOT gate this on routes[key].polylines. A route without map geometry is still a
      // real route: the "Bypass Routing Engine" stop-ordering mode returns no polyline at
      // all, and skipping this block left the route with no name and no jobs, which the
      // backend rejected as a bare 400 on POST /orders. Having jobs is the only condition
      // that matters here.
      {
        const findJobs = tmpJobs.filter((j) => j.routeId === key);
        if (findJobs?.length > 0) {
          tmpRoutes = {
            ...tmpRoutes,
            [key]: {
              ...newOrder.routes[key],
              // Return leg from the routing step, in the units the backend stores (m / s).
              // The backend only keeps it when returnToPickupEnabled is on.
              returnDistance: newOrder.routes[key]?.returnDistance || 0,
              returnDuration:
                newOrder.routes[key]?.returnDuration ||
                Math.round((newOrder.routes[key]?.returnMins || 0) * 60),
              jobs: findJobs
            }
          };
        }
      }
      console.log(
        `[FRONTEND AdminCreateOrder] Processing route ${key}, visibility from routes state:`,
        routes[key]?.visibility
      );
      tmpRoutes = {
        ...tmpRoutes,
        [key]: {
          ...tmpRoutes[key],
          serviceId: routes[key]?.serviceId,
          vehicleCategoryId: routes[key]?.vehicleCategoryId,
          vehicle: routes[key]?.vehicleCategory,
          clientEstimatePrice: routes[key]?.clientEstimatePrice,
          driverEstimatePrice: routes[key]?.driverEstimatePrice,
          visibility: routes[key]?.visibility || "all", // Add visibility field
          driverId: routes[key]?.driverId, // Per-route driver from the service step; blank = unassigned
          importFileId: newOrder?.importFileId, // Add import file ID from draft
          clientRouteEstimate: {
            ...(routes[key]?.clientRouteEstimate || routeEstimateDefault),
            type: ROUTE_ESTIMATE_TYPES.CLIENT_ESTIMATE
          },
          driverRouteEstimate: {
            ...(routes[key]?.driverRouteEstimate || routeEstimateDefault),
            type: ROUTE_ESTIMATE_TYPES.DRIVER_ESTIMATE
          }
        }
      };
      console.log(
        `[FRONTEND AdminCreateOrder] Route ${key} final object visibility:`,
        tmpRoutes[key].visibility
      );
    });

    if (unscheduledJobs?.length > 0) {
      tmpRoutes = {
        ...tmpRoutes,
        unscheduled: {
          name: "unscheduled",
          color: "#c4c4c4",
          jobs: unscheduledJobs
        }
      };
    }
    return convertObjectToArray(tmpRoutes, "id");
  };

  const saveData = async () => {
    const fields = {
      isOptimize: isOptimizeRoute,
      isSamePackages: isAllPackage,
      jobs: convertObjectToArray(newOrder?.jobs, "id"),
      routes: handleAddJobsToRoutes(),
      pickupDate: formatDateToBackend(pickupDate),
      userId: currentUser?.sub,
      clientId,
      driverId,
      routeLocationPacakgeV2Ids: [],
      returnToPickupEnabled,
      returnOnFailedEnabled
    };

    console.log("===SAVE DATA - ADMIN CREATE ORDER PAGE===", {
      fromPlanFlow: newOrder?.isConfirmLocations === true,
      fields,
      newOrderState: newOrder
    });

    const { error } = await dispatch(await doCreateActiveOrder(fields));
    if (!error) {
      // If this order was created from a plan, delete the plan
      if (newOrder?.fromPlanFlow && newOrder?.planId) {
        try {
          await request.delete(`/routeplan/${newOrder.planId}`);
          console.log(
            `Successfully deleted plan ${newOrder.planId} after order creation`
          );
        } catch (deleteError) {
          console.error("Error deleting plan after order creation:", deleteError);
          // Don't block the user flow if plan deletion fails
          message.warning(
            "Order created successfully, but failed to delete the draft plan"
          );
        }
      }

      form.resetFields();
      setImagesAddressInfo(imagesInit);
      dispatch(saveAsDraftNewOrder({}));
      // reset saved pickup date by clearing value
      localStorage.removeItem("pickupDate");
      isAdmin ? history.push("/admin/routes") : history.push("/routes");
    }
  };

  const handleSelectPack = (values) => {
    const newPackages = [...packages];
    const packsData = values.packs;
    const packIds = values.packs.map((p) => p.id);
    packages.forEach((packa) => {
      if (!packIds.includes(packa.id)) return;
      const indexPack = newPackages.findIndex((newP) => packa.id === newP.id);
      const packSend = packsData.find((packD) => packa.id === packD.id);
      const packDropoffs = newPackages[indexPack]?.dropoffs
        ? [...newPackages[indexPack].dropoffs]
        : [];
      const indexDrop = packDropoffs.findIndex((drop) => values.dropId === drop.id);
      if (packSend.value === 0 && indexDrop === -1) return;
      if (packSend.value === 0 && indexDrop !== -1) {
        packDropoffs.splice(indexDrop, 1);
      } else if (packDropoffs.length === 0) {
        packDropoffs.push({
          id: values.dropId,
          quantity: packSend.value
        });
      } else if (indexDrop === -1) {
        packDropoffs.push({
          id: values.dropId,
          quantity: packSend.value
        });
      } else {
        packDropoffs.splice(indexDrop, 1, {
          id: values.dropId,
          quantity: packSend.value
        });
      }
      newPackages[indexPack] = {
        ...newPackages[indexPack],
        dropoffs: packDropoffs
      };
      setPackages(newPackages);
    });
    onCancel();
  };

  const clickModal = () => {
    return selectedInfo.typePack !== "dropoff" ? formPack : formSelectPack;
  };

  const getPackForDrop = (dropId) => {
    if (isAllPackage) {
      return packages;
    } else {
      return packages.filter((pack) => {
        return (
          pack && pack.dropoffs?.length && pack.dropoffs.map((d) => d.id).includes(dropId)
        );
      });
    }
  };

  const getPacksFromSelect = (dropId) => {
    return packages.filter((pack) => {
      if (pack.dropoffs && pack.dropoffs.length) {
        const quantityCurrent = sumBy(
          pack.dropoffs.filter((drop) => drop.id !== dropId),
          "quantity"
        );
        return !(pack.quantity - quantityCurrent === 0);
      }
      return true;
    });
  };

  const getDropoffLocationName = (dropId) => {
    const dropoff = dropoffs.find((d) => d.id === dropId);
    return (
      dropoff?.location_name ||
      dropoff?.address?.location_name ||
      dropoff?.address?.address ||
      "No location selected"
    );
  };

  const onValuesChange = (changedFields, allFields) => {
    if (changedFields.pickups) {
      setPickups(allFields.pickups);
      setIsConfirmRoute(false);
    }
    if (changedFields.dropoffs) {
      setDropoffs(allFields.dropoffs);
      setIsConfirmRoute(false);
    }
    if (changedFields.clientId) {
      setClientId(allFields.clientId);
      setClientType(_find(allClients, { id: allFields.clientId })?.clientType);
    }
    if (changedFields.driverId) {
      setDriverId(allFields.driverId);
    }
  };

  const onchangeIsAllPackage = (checked, e) => {
    e.preventDefault();
    setIsAllPackage(checked);
    setIsConfirmRoute(false);
  };

  // This function is high level, gets called often
  // Don't need to worry about pool data in jobs on the isConfirmRoute (except as a validation)
  // as it SHOULD be set somewhere between Stops > Route > Service path in the 'else' path
  const handleSaveAsDraft = (callback = () => {}) => {
    if (isConfirmRoute) {
      dispatch(
        saveAsDraftNewOrder({
          data: {
            ...newOrder // Keep other data as is
          },
          callback
        })
      );
    } else {
      //console.log("🦾 handleSaveAsDraft called with !isConfirmRoute");
      // existing complex ETL logic to build jobs out of data
      const dataForm = form.getFieldValue();
      const tmpJobs = getJobs({
        imagesAddressInfo,
        packages,
        pickups,
        dropoffs,
        isAllPackage,
        isOptimizeRoute
      });

      // Here we add poolStatus down to each JOB from the newOrder/ using this instead of tmpjobs below
      const jobsWithPoolStatus = tmpJobs.map((job) => ({
        ...job,
        poolStatus: newOrder?.poolStatus,
        isPoolToShift: newOrder?.isPoolToShift
      }));

      let firstPickup = {};
      if (dataForm.pickups[0]) {
        firstPickup = {
          ...dataForm.pickups[0]
        };
      }
      const objJobs = convertArrayToObject(jobsWithPoolStatus, "id"); // Use updated jobs

      /* debugging
      console.log(dataForm.pickups);
      console.log(dataForm.dropoffs);
      console.log("objJobs", objJobs);
      console.log("🦾 check various");
      console.log("🦾 packages: ", packages);
      */

      setJobs(objJobs);
      dispatch(
        saveAsDraftNewOrder({
          data: {
            ...newOrder,
            pickups: dataForm.pickups,
            dropoffs: dataForm.dropoffs,
            isOptimizeRoute,
            imagesAddressInfo,
            isAllPackage,
            packages: packages,
            pickupDate,
            jobs: objJobs, // Use updated jobs
            isConfirmRoute,
            firstPickup,
            clientId,
            driverId
          },
          callback
        })
      );
    }

    dispatch(setSuccessMessage("Saved"));
  };

  /**
   * Writes everything the user has entered by hand — form values plus the local state the
   * form does not own — into the draft, with `extraData` merged in last.
   *
   * `saveAsDraftNewOrder` REPLACES the draft rather than merging into it, and the
   * `[form, newOrder]` effect re-seeds the form from whatever the draft ends up holding.
   * So any dispatch that spreads a `newOrder` which predates the manual entry silently
   * blanks the locations. Every such dispatch must go through here.
   */
  const saveManualDraft = (extraData = {}) => {
    const dataForm = form.getFieldValue();
    let tmpJobs = newOrder.jobs;
    let firstPickup = newOrder.firstPickup;
    if (!isConfirmRoute) {
      tmpJobs = getJobs({
        imagesAddressInfo,
        packages,
        pickups,
        dropoffs,
        isAllPackage,
        isOptimizeRoute,
        isPoolToShift: newOrder?.isPoolToShift
      });
      if (dataForm.pickups?.[0]) {
        firstPickup = {
          ...dataForm.pickups[0]
        };
      }
      tmpJobs = convertArrayToObject(tmpJobs, "id");
    }
    setJobs(tmpJobs);
    dispatch(
      saveAsDraftNewOrder({
        data: {
          ...newOrder,
          routes: { ...newOrder.routes },
          // Fall back to local state so an empty form read can never wipe the stops.
          pickups: dataForm.pickups || newOrder.pickups || pickups,
          dropoffs: dataForm.dropoffs || newOrder.dropoffs || dropoffs,
          isOptimizeRoute,
          imagesAddressInfo,
          isAllPackage,
          packages,
          pickupDate,
          jobs: tmpJobs,
          isConfirmRoute,
          firstPickup,
          clientId,
          driverId,
          ...extraData
        }
      })
    );
  };

  const handleSaveAsDraftByManual = () => {
    saveManualDraft();
    dispatch(setSuccessMessage("Saved"));
  };

  const handleResetAll = () => {
    form.resetFields();
    setConfirmLocations(false);
    setConfirmLocationsNext(false);
    setType("pickups");
    setImagesAddressInfo(imagesInit);
    dispatch(saveAsDraftNewOrder({ data: {} }));
    dispatch(setSuccessMessage("Reset"));
    // reset saved pickup date by clearing value
    localStorage.removeItem("pickupDate");
    setIsAllPackage(true);
  };

  const changeCollapsePick = (props) => {
    setKeysPick([props]);
    const idsErrorPick = keysPick.filter((x) => idErrors.pickups.includes(x));
    if (idsErrorPick.length)
      setTimeout(() => {
        form
          .validateFields()
          .then(() => {})
          .catch(() => {});
      }, 1500);
  };

  const changeCollapsDrop = (props) => {
    setKeysDrop([props]);
    const idsErrorDrop = keysDrop.filter((x) => idErrors.dropoffs.includes(x));
    if (idsErrorDrop.length)
      setTimeout(() => {
        form
          .validateFields()
          .then(() => {})
          .catch(() => {});
      }, 1500);
  };
  const addPickup = () => {
    const pickupsForm = form.getFieldValue("pickups");
    const maxPosition = Math.max(...pickupsForm.map((p) => p.position), 1);
    return {
      ...init,
      id: `${new Date().getTime()}-${makeId(4)}-Pickup`,
      title: "Pickup Location",
      position: maxPosition + 1
    };
  };

  const addDropoff = () => {
    const dropoffsForm = form.getFieldValue("dropoffs");
    const maxPosition = Math.max(...dropoffsForm.map((p) => p.position), 1);

    // Once we add dropoff enable/disbale all packages
    // delivered to same location
    setIsAllPackage(disAllPack);

    return {
      ...init,
      id: `${new Date().getTime()}-${makeId(4)}-Dropoff`,
      title: "Drop-off Location",
      position: maxPosition + 1
    };
  };

  const handleHeader = (pickup, index, name, remove, array, stepType) => {
    const pickupId = parseInt(pickup?.id);
    let stopPacks = packages.filter((pa) => pa.pickupId.toString().includes(pickupId));
    let newArr = array.map((arr) => arr && parseInt(arr));
    let packagesQty = 0;

    if (stepType !== "dropoffs") {
      packagesQty = stopPacks.reduce((acc, curr) => {
        return acc + parseInt(curr.quantity);
      }, 0);
    } else {
      // This will help show correct quantity of packages per dropoffs
      let drops = packages.find((pack) => pack?.dropoffs)
        ? packages.map((packDrop) => packDrop.dropoffs)
        : [{}];
      drops = [].concat(...drops);
      drops = [drops[index]];

      packagesQty = drops.reduce((acc, curr) => {
        return acc + parseInt(curr?.quantity || 0);
      }, 0);
    }

    return (
      <div className="header-collapse">
        <div className="top">
          <div>
            {newArr?.includes(pickupId) ? (
              <>
                <h3 className="mb-4">
                  {pickup?.title || pickup?.type} {index + 1}
                </h3>
                <p className="simple-text">
                  Enter {stepType === "pickups" ? "pickup" : "dropoff"} details.
                </p>
              </>
            ) : (
              <>
                <h3 className="mb-4">
                  {pickup?.title || pickup?.type} {index + 1}
                </h3>
                <Row gutter={5}>
                  <Col md={24}>
                    <p className="header-text">
                      <span>
                        <strong>{pickup?.location_name || ""}</strong>{" "}
                      </span>
                      <span className="header-sub-text">{pickup?.address.address}</span>
                    </p>
                    <p className="header-text">{pickup?.contact_name || ""}</p>
                    <p className="header-text">
                      {packagesQty ? packagesQty + " Packages" : 0 + " Packages"}
                    </p>
                    {pickup?.address.address && (
                      <Button className="action-button">Edit Location</Button>
                    )}
                  </Col>
                </Row>
              </>
            )}
          </div>
        </div>
        {index > 0 && (
          <Popconfirm
            title="Are you sure you want to delete this location?"
            onConfirm={(e) => {
              handleClickDeletePickup(name, remove, e, pickup.id, stepType);
            }}
            okText="Yes"
            cancelText="No"
          >
            <ReactSVG
              className="icon"
              src="/icons/delete-icon.svg"
              style={{
                top: "3px"
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </Popconfirm>
        )}
      </div>
    );
  };

  const onCancel = () => {
    formPack.resetFields();
    setSelectedPack(null);
    setSelectedInfo({});
    setVisible(false);
  };

  const openPackCreateUpdate = (ac, id, typePack, pack = null) => {
    setVisible(true);
    setSelectedPack({
      ...pack
    });
    setSelectedInfo({
      id,
      typePack
    });
    setIsConfirmRoute(false);
  };

  const openSelectedPack = (dropId) => {
    setSelectedInfo({
      id: dropId,
      typePack: "dropoff"
    });
    setVisible(true);
    setIsConfirmRoute(false);
  };

  const handleSavePack = (values) => {
    const pickupId = selectedInfo?.id;
    const newPackages = [...packages];
    if (!values.id) {
      newPackages.push({
        ...values,
        pickupId: pickupId,
        id: `${new Date().getTime()}-${pickupId}pack`
      });
    } else {
      const indexpack = newPackages.findIndex((pack) => pack.id === values.id);
      delete values.id;
      const newPack = {
        ...newPackages[indexpack],
        ...values
      };
      newPackages.splice(indexpack, 1, newPack);
    }
    setPackages(newPackages);
    onCancel();
  };

  const removePack = (values) => {
    const newPackages = [...packages];
    const indexpack = newPackages.findIndex((pack) => pack.id === values.id);
    newPackages.splice(indexpack, 1);
    setPackages(newPackages);
  };

  const onChangePickupLocationSearch = (value, pickupId) => {
    const pickupsForm = [...form.getFieldValue("pickups")];
    const indexPickup = pickupsForm.findIndex((pickup) => pickup.id === pickupId);
    pickupsForm[indexPickup].location_name = value;
    setPickups(pickupsForm);
  };
  const onChangeDropoffLocationSearch = (value, pickupId) => {
    const dropoffsFrom = [...form.getFieldValue("dropoffs")];
    const indexDropoff = dropoffsFrom.findIndex((pickup) => pickup.id === pickupId);
    dropoffsFrom[indexDropoff].location_name = value;
    setDropoffs(dropoffsFrom);
  };

  const onChangePickupAddress = (value, pickupId) => {
    const pickupsFrom = [...form.getFieldValue("pickups")];
    const indexPickup = pickupsFrom.findIndex((pickup) => pickup.id === pickupId);
    const pickupFrom = { ...pickupsFrom[indexPickup] };
    if (pickupFrom) {
      pickupFrom.address = {
        address: value.address,
        lngLat: value.lngLat
      };
      pickupsFrom.splice(indexPickup, 1, pickupFrom);
      form.setFieldsValue({
        pickups: pickupsFrom
      });
      setPickups(pickupsFrom);
    }
    setIsConfirmRoute(false);
  };

  const onChangeDropoffAddress = (value, dropoffId) => {
    const dropoffFrom = [...form.getFieldValue("dropoffs")];
    const indexDropoff = dropoffFrom.findIndex((dropoff) => dropoff.id === dropoffId);
    const pickupFrom = { ...dropoffFrom[indexDropoff] };
    if (pickupFrom) {
      pickupFrom.address = {
        address: value.address,
        lngLat: value.lngLat
      };
      dropoffFrom.splice(indexDropoff, 1, pickupFrom);
      form.setFieldsValue({
        dropoffs: dropoffFrom
      });
      setDropoffs(dropoffFrom);
    }
    setIsConfirmRoute(false);
  };

  useEffect(() => {
    setIsEmptyPickupAddress(
      !pickups
        .map((pickup) => pickup.address.lngLat[0] !== undefined)
        .every((item) => item)
    );
  }, [pickups]);
  useEffect(() => {
    setIsEmptyDropoffAddress(
      !dropoffs
        .map((dropoff) => dropoff.address.lngLat[0] !== undefined)
        .every((item) => item)
    );
  }, [pickups, dropoffs, packages]);

  useEffect(() => {
    const hasEmptyPhone = (items) => {
      return items.some(
        (item) =>
          !item.phone_numbers ||
          item.phone_numbers.length === 0 ||
          item.phone_numbers.some(
            (phoneObj) => !phoneObj.phone || phoneObj.phone.trim() === ""
          )
      );
    };

    const dropoffsHasEmpty = hasEmptyPhone(dropoffs);
    const pickupsHasEmpty = hasEmptyPhone(pickups);

    setIsEmptyPhone(dropoffsHasEmpty || pickupsHasEmpty);
  }, [dropoffs, pickups]);

  const onChangeTime = (value, id, name, fieldName) => {
    const dropoffFrom = [...form.getFieldValue(name)];
    const indexDropoff = dropoffFrom.findIndex((dropoff) => dropoff.id === id);
    const pickupFrom = { ...dropoffFrom[indexDropoff] };
    const tmpObject = {};
    if (pickupFrom) {
      pickupFrom[fieldName] = value;
      dropoffFrom.splice(indexDropoff, 1, pickupFrom);
      tmpObject[name] = dropoffFrom;
      form.setFieldsValue(tmpObject);
      name === "pickups" ? setPickups(dropoffFrom) : setDropoffs(dropoffFrom);
    }
    setIsConfirmRoute(false);
  };

  const handleClickDeletePickup = (name, actionFunc, e, id, stepType) => {
    e.stopPropagation();
    if (stepType === "pickups") {
      const deletePackIds =
        packages.filter((pack) => pack.pickupId === id)?.map((p) => p.id) || [];
      const newPacks = packages.filter((pack) => !deletePackIds.includes(pack.id));
      setPackages(newPacks);
    } else {
      const packsHasDrop =
        packages.filter(
          (pack) => pack.dropoffs?.length > 0 && pack.dropoffs.find((d) => d.id === id)
        ) || [];
      if (packsHasDrop.length) {
        const newPacks = packages.map((pack) => ({
          ...pack,
          dropoffs: [...(pack.dropoffs || [])]
        }));
        packsHasDrop.forEach((packD) => {
          const packIndex = packages.findIndex((pa) => pa.id === packD.id);
          if (packIndex !== -1) {
            // Remove the dropoff by filtering it out (instead of splice)
            newPacks[packIndex].dropoffs = newPacks[packIndex].dropoffs.filter(
              (d) => d.id !== id
            );
          }
        });
        setPackages(newPacks);
      }
    }
    actionFunc(name);
    setIsConfirmRoute(false);
  };

  const handleClickService = () => {
    if (isAdmin && !clientId) {
      return notification.error({
        message: "Error!",
        description: "Please select a client",
        placement: "topRight",
        style: { width: "auto" }
      });
    }

    const { isValid, errorGroups } = validateRouteData();
    if (!isValid) {
      notification.destroy();
      return notification.error({
        message: "Missing Required Fields",
        description: (
          <div>
            <p>The following fields are required for route optimization:</p>
            <div style={{ marginTop: 8 }}>
              {errorGroups.map((group, i) => (
                <div key={i} style={{ marginBottom: 12 }}>
                  <strong>{group.type}:</strong>
                  <ul style={{ marginTop: 4, marginBottom: 0, paddingLeft: 20 }}>
                    {group.errors.map((error, j) => (
                      <li key={j}>{error}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        ),
        placement: "topRight",
        duration: 6,
        style: { width: "auto" }
      });
    }
    console.log(newOrder);

    dispatch(
      saveAsDraftNewOrder({
        data: {
          ...newOrder // Keep other data as is
        }
      })
    );
    setConfirmLocations(true);
    // Use setTimeout to ensure panel is rendered before opening it
    setTimeout(() => {
      setCollapseStepsActiveKey("route-optimization");
    }, 100);
    handleSaveAsDraft(() => null);
  };

  /**
   * Persists the Step 3 stop-ordering choice on the draft and clears the confirmed-route
   * flag, so changing it re-runs optimization rather than showing a stale plan.
   *
   * Goes through saveManualDraft rather than spreading `newOrder` directly: the picker
   * modal opens as soon as Step 3 mounts, and for a hand-entered order the draft can still
   * be behind the form at that moment. Spreading it here blanked the locations.
   */
  const handleChangeStopOrderMode = (stopOrderMode) => {
    saveManualDraft({ stopOrderMode, isConfirmRoute: false });
    dispatch(resetNewOrderStatuses());
  };

  // Return Process for this order, seeded from the selected client's Settings > Return
  // Process defaults (see ReturnProcessSelect). Lives in the draft alongside stopOrderMode.
  const clientReturnProcess = useClientReturnProcess({ clientId, isAdmin: true });
  const returnToPickupEnabled =
    newOrder?.returnToPickupEnabled ?? clientReturnProcess.defaults.returnToPickupEnabled;
  const returnOnFailedEnabled =
    newOrder?.returnOnFailedEnabled ?? clientReturnProcess.defaults.returnOnFailedEnabled;
  const handleChangeReturnProcess = (values) => {
    saveManualDraft(values);
  };

  const handleConfirmRouteOptimization = () => {
    dispatch(
      saveAsDraftNewOrder({
        data: {
          ...newOrder,
          routes: filterValidRoutes(newOrder.routes),
          isConfirmRoute: true,
          isConfirmLocations: true
        }
      })
    );
    redirectToNewJobsPageAgain();
  };

  const redirectToNewJobsPageAgain = () => {
    console.log("redirect");
  };

  return (
    <div className="CreateOrderPage">
      <div
        style={{
          padding: "0 0 6px 1em",
          top: 0
        }}
        className="sticky-wrapper"
      >
        <div className="title-container">
          <h2 className="page-title">Plan Your Delivery Routes</h2>
          <p>Create, optimize, and upload routes for efficient delivery management.</p>
        </div>
        <div className="flex-container mb-3">
          <Button className="action-button mr-1">
            Select Service <CheckOutlined />
          </Button>
          <Button
            className={`action-button ${!confirmLocations ? "active" : ""} ml-1 mr-1`}
          >
            Add Locations {!confirmLocations ? "" : <CheckOutlined />}
          </Button>
          <Button className={`action-button ${isConfirmRoute ? "" : "active"}`}>
            Optimize Routes {isConfirmRoute ? <CheckOutlined /> : ""}
          </Button>
        </div>
      </div>
      <div className="wrapper">
        <div className="contentForm">
          <div className="order-create-container">
            <Form
              onValuesChange={onValuesChange}
              scrollToFirstError={true}
              layout="vertical"
              form={form}
              hideRequiredMark
              colon={false}
              initialValues={{
                pickups: pickupsInit,
                dropoffs: dropoffsInit
              }}
            >
              <section>
                <Collapse
                  accordion
                  expandIconPosition="right"
                  className={`${isConfirmRoute ? "collapse-disabled" : ""}`}
                  collapsible={isConfirmRoute ? "disabled" : ""}
                  defaultActiveKey={[1]}
                  activeKey={[collapseStepsActiveKey]}
                  onChange={(collapseKey) => setCollapseStepsActiveKey(collapseKey)}
                >
                  <Panel
                    header={
                      <div className="panel-header">
                        <p>
                          <span>Step 1: </span>
                          <span>Service Selected</span>
                        </p>
                        <p>Click arrow to review.</p>
                      </div>
                    }
                  >
                    <p
                      style={{
                        fontSize: "1.3em",
                        margin: "0 0 0 15px",
                        color: "#004dbc"
                      }}
                    >
                      {selectedService?.name || "No service selected."}
                    </p>
                  </Panel>
                  <Panel
                    header={
                      <>
                        <div className="panel-header">
                          <p>
                            <span>Step 2: </span>
                            <span>Upload or Enter Route Data</span>
                          </p>
                          <p>
                            Upload a file or manually enter address data to start planning
                            your route.
                          </p>
                        </div>
                        <Row>
                          <Col span={12}>
                            <Form.Item
                              label="Client"
                              name="clientId"
                              rules={[{ required: true, message: "Required" }]}
                              value={clientId}
                            >
                              <Select
                                className="group-select-custom"
                                size="large"
                                placeholder="Please Select"
                                showSearch={true}
                                optionFilterProp="children"
                                onClick={(e) => e.stopPropagation()}
                                onChange={() => {
                                  setConfirmLocations(false);
                                  setConfirmLocationsNext(false);
                                }}
                              >
                                {keys(groupedClients).map((groupKey) => (
                                  <Select.OptGroup key={groupKey} label={`${groupKey}s`}>
                                    {groupedClients[groupKey].map((user) => (
                                      <Select.Option key={user.id} value={user.id}>
                                        {user.clientName}
                                        <span className="hint">
                                          {user.supportEmail
                                            ? ` (${user.supportEmail})`
                                            : ""}
                                        </span>
                                      </Select.Option>
                                    ))}
                                  </Select.OptGroup>
                                ))}
                              </Select>
                            </Form.Item>
                            <Form.Item
                              label={
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    gap: "10%"
                                  }}
                                >
                                  <div className="left">Driver</div>
                                  <div
                                    className="right"
                                    style={{
                                      fontWeight: 400,
                                      color: "#888888"
                                    }}
                                  >
                                    (Optional)
                                  </div>
                                </div>
                              }
                              name="driverId"
                              value={driverId}
                            >
                              <Select
                                className="group-select-custom"
                                size="large"
                                placeholder="Please Select"
                                showSearch={true}
                                optionFilterProp="children"
                                onClick={(e) => e.stopPropagation()}
                              >
                                {allDrivers.map((driver) => (
                                  <Select.Option key={driver.id} value={driver.id}>
                                    {`${fullName(driver)} (${driver.email})`}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    }
                  >
                    <Row gutter={10}>
                      <Col md={19} className="search-header">
                        <Input
                          type="search"
                          placeholder="Look up address"
                          prefix={<SearchOutlined />}
                          onChange={(value) => console.log(value)}
                        />
                        <Button className="d-flex flex-row action-button active">
                          Search
                        </Button>
                      </Col>
                    </Row>
                    <Form.List name="pickups">
                      {(fields, { add, remove }) => {
                        return (
                          <>
                            <div className="pickups block">
                              <Collapse
                                accordion
                                activeKey={keysPick}
                                onChange={changeCollapsePick}
                                ghost
                                expandIconPosition="right"
                              >
                                {fields.map(
                                  ({ key, name, fieldKey, isListField }, index) => {
                                    const pickupData =
                                      form.getFieldValue("pickups")[index];
                                    return (
                                      <Panel
                                        header={handleHeader(
                                          pickupData,
                                          index,
                                          name,
                                          remove,
                                          keysPick,
                                          "pickups"
                                        )}
                                        className={
                                          idErrors["pickups"].includes(pickupData.id) &&
                                          "error-panel"
                                        }
                                        key={pickupData.id}
                                        // extra={genExtra(index, name, remove)}
                                      >
                                        <AddressFormAdmin
                                          stepType="pickups"
                                          setAddress={onChangePickupAddress}
                                          handleLocationNameUpdate={
                                            onChangePickupLocationSearch
                                          }
                                          address={pickupData.address}
                                          orderData={pickupData}
                                          id={pickupData.id}
                                          keyValue={key}
                                          nameValue={name}
                                          fieldKey={fieldKey}
                                          isListField={isListField}
                                          key={key}
                                          form={form}
                                          onChangeTime={onChangeTime}
                                          imagesAddressInfo={imagesAddressInfo}
                                          setImagesAddressInfo={setImagesAddressInfo}
                                          clientId={clientId}
                                        />
                                        <PackageList
                                          key={`${key}-pickup-pack`}
                                          packages={packages.filter(
                                            (pa) => pa.pickupId === pickupData.id
                                          )}
                                          pickupId={pickupData.id}
                                          editPack={(pack) =>
                                            openPackCreateUpdate(
                                              "edit",
                                              pickupData.id,
                                              "pickup",
                                              pack
                                            )
                                          }
                                          addPack={() => {
                                            openPackCreateUpdate(
                                              "new",
                                              pickupData.id,
                                              "pickup"
                                            );
                                          }}
                                          removePack={removePack}
                                        />
                                      </Panel>
                                    );
                                  }
                                )}
                              </Collapse>
                              <Button
                                size="large"
                                className="add-all justify-content-center"
                                onClick={() => add(addPickup())}
                              >
                                <ReactSVG
                                  src="/icons/plus.svg"
                                  className="react-icon mr-4"
                                />
                                Add Another Pickup Location
                              </Button>
                            </div>
                          </>
                        );
                      }}
                    </Form.List>
                    <Form.List name="dropoffs">
                      {(fieldDropoffs, { add, remove }) => {
                        return (
                          <div className="dropoffs block">
                            <Collapse
                              accordion
                              activeKey={keysDrop}
                              onChange={changeCollapsDrop}
                              ghost
                              expandIconPosition="right"
                            >
                              {fieldDropoffs.map(
                                ({ key, name, fieldKey, isListField }, index) => {
                                  const dropoffData =
                                    form.getFieldValue("dropoffs")[index];
                                  return (
                                    <Panel
                                      header={handleHeader(
                                        dropoffData,
                                        index,
                                        name,
                                        remove,
                                        keysDrop,
                                        "dropoffs"
                                      )}
                                      key={dropoffData.id}
                                      className={
                                        idErrors["dropoffs"].includes(dropoffData.id) &&
                                        "error-panel"
                                      }
                                    >
                                      <AddressFormAdmin
                                        clientId={clientId}
                                        stepType="dropoffs"
                                        setAddress={onChangeDropoffAddress}
                                        handleLocationNameUpdate={
                                          onChangeDropoffLocationSearch
                                        }
                                        address={dropoffData.address}
                                        orderData={dropoffData}
                                        id={dropoffData.id}
                                        keyValue={key}
                                        nameValue={name}
                                        fieldKey={fieldKey}
                                        isListField={isListField}
                                        key={key}
                                        form={form}
                                        onChangeTime={onChangeTime}
                                        imagesAddressInfo={imagesAddressInfo}
                                        setImagesAddressInfo={setImagesAddressInfo}
                                      />

                                      <PackageListDrop
                                        id={dropoffData.id}
                                        packages={getPackForDrop(dropoffData.id)}
                                        selectedPack={() =>
                                          openSelectedPack(dropoffData.id)
                                        }
                                        isAll={isAllPackage}
                                      />
                                    </Panel>
                                  );
                                }
                              )}
                            </Collapse>
                            <Button
                              size="large"
                              className="add-all justify-content-center"
                              onClick={() => add(addDropoff())}
                            >
                              <ReactSVG
                                src="/icons/plus.svg"
                                className="react-icon mr-4"
                              />
                              Add Another Dropoff Location
                            </Button>
                          </div>
                        );
                      }}
                    </Form.List>
                  </Panel>
                  {confirmLocationsNext && (
                    <Panel
                      header={
                        <div className="panel-header">
                          <p>
                            <span>Step 3: </span>
                            <span>Confirm Pick Up and Drop Off Locations</span>
                          </p>
                          <p>
                            Review and confirm your pickup and drop-off locations to
                            ensure accurate delivery.
                          </p>
                        </div>
                      }
                    >
                      {/* preferredNoOfStops is omitted: this page has no client record in
                          scope, so the component falls back to 15 — the same admin default
                          ConfirmRoutePageAdmin uses. It only affects when the OSRM-optimize
                          option is greyed out; the backend enforces the real cap either way. */}
                      <StopOrderingSelect
                        stopOrderMode={newOrder?.stopOrderMode || DEFAULT_STOP_ORDER_MODE}
                        setStopOrderMode={handleChangeStopOrderMode}
                        dropoffs={dropoffs}
                      />

                      <ReturnProcessSelect
                        returnToPickupEnabled={returnToPickupEnabled}
                        returnOnFailedEnabled={returnOnFailedEnabled}
                        defaults={clientReturnProcess.defaults}
                        settings={clientReturnProcess.settings}
                        loading={clientReturnProcess.loading}
                        clientMissing={!clientId}
                        onChange={handleChangeReturnProcess}
                      />

                      <div className="location-map">
                        <div className="pin-map">
                          <MapImportPreview
                            routes={[...pickups, ...dropoffs]}
                            isLocation={true}
                            title=""
                          />
                        </div>
                        <Row gutter={30}>
                          <Col className="d-flex">
                            <img
                              src="/icons/map-pinpoint-blue.svg"
                              style={{ width: 30 }}
                              height={30}
                            />
                            <p className="pt-1 pl-3 pr-3 m-0 pin-legend-text">
                              Pickup Location
                            </p>
                          </Col>
                          <Col className="d-flex">
                            <img
                              src="/icons/map-pinpoint-orange.svg"
                              style={{ width: 30 }}
                              height={30}
                            />
                            <p className="pt-1 pl-3 pr-3 m-0 pin-legend-text">
                              Dropoff Location
                            </p>
                          </Col>
                        </Row>
                      </div>
                      <Row gutter={20}>
                        <Col md={12}>
                          <p className="location-title">Pickup Locations</p>
                          {pickups.length && (
                            <>
                              {pickups.map((pickup, pickupIdx) => (
                                <div
                                  key={pickupIdx + 1}
                                  className="confirm-location-wrapper"
                                >
                                  <span className="location-num location-num__pick">
                                    {pickupIdx + 1}
                                  </span>
                                  <Input
                                    value={pickup?.address?.address}
                                    className="location-input ml-2"
                                  />
                                </div>
                              ))}
                            </>
                          )}
                        </Col>
                        <Col md={12}>
                          <p className="location-title">Dropoff Locations</p>
                          {dropoffs.map((pickup, dropIdx) => (
                            <div key={dropIdx + 1} className="confirm-location-wrapper">
                              <span className="location-num location-num__drop">
                                {dropIdx + 1}
                              </span>
                              <Input
                                value={pickup?.address?.address}
                                className="location-input ml-2"
                              />
                            </div>
                          ))}
                        </Col>
                      </Row>
                    </Panel>
                  )}
                  {confirmLocations && (
                    <Panel
                      key="route-optimization"
                      header={
                        <div className="panel-header">
                          <p>
                            <span>Step 4: </span>
                            <span>Route Optimization</span>
                          </p>
                          <p>
                            Streamline deliveries with Flexio{"'"}s smart route
                            optimization, saving time and cutting costs.
                          </p>
                        </div>
                      }
                    >
                      {isConfirmRoute ? (
                        <></>
                      ) : (
                        <ConfirmRoutePageAdmin
                          isAdmin={true}
                          redirect={false}
                          handleConfirmState={() => {
                            setConfirmLocations(false);
                            setConfirmLocationsNext(false);
                          }}
                        />
                      )}
                    </Panel>
                  )}
                </Collapse>
              </section>
            </Form>
          </div>
        </div>
        {type === "service" && (
          <>
            <ServiceStep
              flexioServices={flexioServices}
              pickupDate={pickupDate}
              setPickupDate={setPickupDate}
              routes={routes}
              setRoutes={setRoutes}
              estimatePriceOrganization={clientType === "organization"}
              clientId={clientId}
            />
          </>
        )}
      </div>

      <div className="footer" style={{ position: "fixed", bottom: 0, paddingLeft: 300 }}>
        <div>
          <Button
            size="large"
            onClick={() => {
              if (!confirmLocationsNext && !confirmLocations && !isConfirmRoute) {
                return;
              } else if (confirmLocationsNext && !confirmLocations && !isConfirmRoute) {
                setCollapseStepsActiveKey(1);
                setConfirmLocationsNext(false);
              } else if (confirmLocations && !isConfirmRoute) {
                setCollapseStepsActiveKey(2);
                setConfirmLocationsNext(true);
                setConfirmLocations(false);
              } else if (isConfirmRoute) {
                setCollapseStepsActiveKey(null);
                setConfirmLocations(true);
                setIsConfirmRoute(false);
                dispatch(
                  saveAsDraftNewOrder({
                    data: {
                      ...newOrder,
                      isConfirmRoute: false
                    }
                  })
                );
                dispatch(resetNewOrderStatuses());
              }
            }}
          >
            <ArrowLeftOutlined /> Go Back
          </Button>
        </div>
        <div>
          <Button size="large" onClick={handleResetAll}>
            Reset
          </Button>
        </div>
        <div>
          {isConfirmRoute && (
            <Button
              size="large"
              className="svg-icon modify"
              type="link"
              onClick={() => {
                // This will reset to step 2
                dispatch(
                  saveAsDraftNewOrder(
                    {
                      data: {
                        ...newOrder,
                        // Set isConfirmRoute because it will keep showing step 4
                        isConfirmRoute: false
                      }
                    },
                    () => null
                  )
                );
                setCollapseStepsActiveKey(1);
                setIsConfirmRoute(false);
                setConfirmLocations(false);
                setConfirmLocationsNext(false);
                setType("pickups");
              }}
            >
              Modify Route <ReactSVG src="/icons/edit_road.svg" className="icon" />
            </Button>
          )}

          <Button
            size="large"
            className="save-as"
            onClick={() => handleSaveAsDraftByManual()}
          >
            Save as Draft <ReactSVG src="/icons/draf.svg" className="icon" />
          </Button>
          {/* <Button
            type="primary"
            size="large"
            className="create-order"
            onClick={isConfirmRoute ? onFinishOrder : handleClickService}
            loading={isLoading}
          >
            {isConfirmRoute ? "Create Jobs" : "Confirm Route"}
            <CheckCircleOutlined />
          </Button> */}
        </div>
        {!confirmLocationsNext && (
          <Button
            style={{
              backgroundColor: "#15BCE8",
              color: "#fff",
              border: 0,
              padding: 8
            }}
            onClick={() => {
              const { isValid, errorGroups } = validateRouteData();

              if (!isValid) {
                notification.destroy();
                return notification.error({
                  message: "Missing Required Fields",
                  description: (
                    <div>
                      <p>The following fields are required for route optimization:</p>
                      <div style={{ marginTop: 8 }}>
                        {errorGroups.map((group, i) => (
                          <div key={i} style={{ marginBottom: 12 }}>
                            <strong>{group.type}:</strong>
                            <ul
                              style={{ marginTop: 4, marginBottom: 0, paddingLeft: 20 }}
                            >
                              {group.errors.map((error, j) => (
                                <li key={j}>{error}</li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    </div>
                  ),
                  placement: "topRight",
                  duration: 6,
                  style: {
                    width: "auto"
                  }
                });
              }

              // Persist the hand-entered locations before Step 3 mounts. Without this the
              // draft is still empty when the stop-ordering picker fires its first save,
              // and that save — spreading an empty draft — blanked the whole order.
              handleSaveAsDraftByManual();
              setCollapseStepsActiveKey(2);
              setConfirmLocationsNext(true);
            }}
          >
            Next Step <ArrowRightOutlined />
          </Button>
        )}
        {confirmLocationsNext && !confirmLocations && (
          <Button
            style={{
              backgroundColor: "#15BCE8",
              color: "#fff",
              border: 0,
              padding: 10
            }}
            onClick={handleClickService}
            loading={isLoading}
          >
            Confirm Locations Added
          </Button>
        )}
        {!isConfirmRoute && confirmLocations && (
          <Button
            style={{
              backgroundColor: "#15BCE8",
              color: "#fff",
              border: 0,
              padding: 10
            }}
            className="confirm-button"
            onClick={handleConfirmRouteOptimization}
            disabled={
              isSelectRouteNumber ||
              [DND_STATUSES.SORT, DND_STATUSES.OPTIMIZE].includes(dndStatus)
            }
          >
            Confirm Route Optimization
          </Button>
        )}
        {type === "service" && (
          <Button
            style={{
              backgroundColor: "#15BCE8",
              color: "#fff",
              border: 0,
              padding: 10
            }}
            onClick={onFinishOrder}
            loading={isLoading}
          >
            Confirm Routes
          </Button>
        )}
      </div>
      <Modal
        title={
          !selectedPack && selectedInfo.typePack !== "dropoff" ? (
            <div>Add Package</div>
          ) : selectedPack && selectedInfo.typePack !== "dropoff" ? (
            <div>Edit Package</div>
          ) : (
            <div>Select Package</div>
          )
        }
        visible={visible}
        onCancel={onCancel}
        footer={
          <div className="buttons-modal">
            <Form.Item>
              <Button size="large" onClick={onCancel}>
                Cancel
              </Button>
              <Button size="large" type="primary" onClick={() => clickModal().submit()}>
                Confirm
                <CheckCircleOutlined />
              </Button>
            </Form.Item>
          </div>
        }
        width={792}
      >
        {selectedInfo.typePack !== "dropoff" && (
          <PackForm
            pack={selectedPack}
            formPack={formPack}
            onOk={handleSavePack}
            packageTypeList={packageTypeList}
            poolPackages={
              selectedPack?.packagesV2
                ? selectedPack?.packagesV2.filter(
                    (pkgV2) => pkgV2?.packageTypeId === selectedPack?.packageTypeId
                  )
                : []
            }
          />
        )}
        {selectedInfo.typePack === "dropoff" && (
          <SelectPack
            packages={getPacksFromSelect(selectedInfo.id)}
            packageTypeList={packageTypeList}
            formSelectPack={formSelectPack}
            dropId={selectedInfo.id}
            dropoffAddress={getDropoffLocationName(selectedInfo.id)}
            pickups={pickups}
            dropoffs={dropoffs}
            onOk={handleSelectPack}
          />
        )}
      </Modal>
    </div>
  );
};
export default AdminCreateOrderPage;
